import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';

const NavigationService = (() => {
  const service = {};
  const BASE_URL = Environment.getBaseURL();

  const getNavigationItems = auth => axios.get(`${BASE_URL}/navigation`, {
    headers: {
      Authorization: auth.token,
    },
  });

  service.getNavigationItems = getNavigationItems;
  return service;
})();

export default NavigationService;
